module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-comment"
  }, [_c('div', {
    staticClass: "comment-user"
  }, [_c('span', {
    staticClass: "user-name"
  }, [_vm._v("疯狂的迷弟: ")]), _vm._v(" "), _c('p', {
    staticClass: "text-comment"
  }, [_vm._v("王祖贤越看越美")]), _vm._v(" "), _c('a', {
    ref: "replyBtnRef",
    staticClass: "reply-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showReply = !_vm.showReply
      }
    }
  }, [_vm._v("回复")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clickout",
      rawName: "v-clickout",
      value: (['replyBtnRef']),
      expression: "['replyBtnRef']"
    }],
    staticClass: "reply",
    on: {
      "clickout": function($event) {
        _vm.showReply = false
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReply),
      expression: "showReply"
    }],
    staticClass: "reply-area"
  }, [_c('input', {
    staticClass: "ipt-reply",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reply-option"
  }, [_c('button', [_vm._v("发送")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1d2871","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/commentItem.vue
// module id = 15
// module chunks = 0